import type { ComponentType, ReactNode } from 'react';

import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import {
  useRedirectToSignin,
  useRedirectToSignup,
} from '#src/hooks/auth/useRedirectToLandingWithAction.tsx';

export const RequireAuth: ComponentType<
  React.PropsWithChildren<{
    to?: string;
    redirectTo?: 'signin' | 'signup';
  }>
> = ({ children, to, redirectTo }): ReactNode => {
  const { currentUser } = useCurrentUserContext();
  const redirectToSignin = useRedirectToSignin(to);
  const redirectToSignup = useRedirectToSignup(to);

  if (!currentUser) {
    return redirectTo === 'signup' ? redirectToSignup() : redirectToSignin();
  }

  return children;
};

export const requireAuth = <P extends object>(Component: ComponentType<P>) => {
  const RequireAuthWrapper = (props: P) => (
    <RequireAuth>
      <Component {...props} />
    </RequireAuth>
  );
  Object.assign(RequireAuthWrapper, Component);
  return RequireAuthWrapper;
};
